
import { defineComponent, onBeforeMount, ref } from 'vue';
// import { MenuIcon } from 'vue-feather-icons';
import { APP_ENV } from '@/plugins/axios/index';
import vClickOutside from 'v-click-outside';
import GenericV2 from '@/components/global/GenericModalV2.vue';
import moment from 'moment';
import { postApi } from '@/utils/ApiCalls';
// import { fetchInitialData } from '@/utils/header_service';
// import Moment from 'moment';

export default defineComponent({
  name: 'HeaderComp',
  props: {
    showMenuIcon: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // MenuIcon,
    SideMenu: () => import('@/components/global/SideMenu.vue'),
    GenericV2,
  },
  directives: { clickOutside: vClickOutside.directive },
  // props: ['query'],
  setup(props) {
    // const skillId = ref(localStorage.getItem('skillId'));
    // const proficiencyId = ref(localStorage.getItem('profId'));
    // const programId = ref(localStorage.getItem('programId'));
    // console.log(skillId);
    // const initialData = ref();
    // const videoUrl = ref();
    // const helpmateLink = ref();
    const env = ref(APP_ENV);
    console.log(`props.showMenuIcon ${props.showMenuIcon}`);
    const lastAccessedOn = ref(localStorage.getItem('lastAccess'));
    const learnerKey = ref(localStorage.getItem('user_key'));
    const learnerName = ref(localStorage.getItem('userName'));
    const showChatbotTooltip = ref(false);
    const modalVisible = ref(false);

    const upcomingMaintainanceEnd = moment('01-03-2023', 'DD-MM-YYYY').utc();
    const now = moment().utc();
    // console.log(upcomingMaintainanceStart.format());
    // console.log(upcomingMaintainanceEnd.format());
    // console.log(now.format());
    console.log(`last Access ${lastAccessedOn.value} and learner key ${learnerKey.value} and leanrerName ${learnerName.value}`);
    // console.log(`props ${JSON.stringify(props.showMenuIcon)}`);
    const showHideMenu = ref(false);

    const closeModal = () => {
      modalVisible.value = false;
    };

    onBeforeMount(async () => {
      console.log(`APP ENV ${APP_ENV}`);
      if (now.isBefore(upcomingMaintainanceEnd, 'minutes')) {
        console.log(localStorage.getItem('upcoming-maintanence'));
        if (!localStorage.getItem('upcoming-maintanence')) {
          modalVisible.value = true;
          localStorage.setItem('upcoming-maintanence', 'true');
        }
      }
      if (!learnerKey.value) {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user) learnerKey.value = user.ohrId;
      }
      if (!lastAccessedOn.value) lastAccessedOn.value = moment().format('MMM Do YYYY, h:mm a');
      console.log(`learner name ${learnerName.value}`);
      if (!learnerName.value) learnerName.value = '';
    });
    const saveAiGuruEvent = async () => {
      try {
        console.log(`save event call triggered`);
        console.log(`App environment`, APP_ENV);
        const url_for_event = APP_ENV === 'prod' ? `https://api-v2.genpact.com/api/delphi/event` : `https://api-v2-dev.genpact.com/api/delphi/event`;
        const res: any = await postApi(url_for_event, { event_type: 'learner_consent_to_ama' });
        // console.log(`event ai guru response`, res);
      } catch (error) {
        console.log(`something went wrong in aiGuru event call`, error);
      }
    };
    const menuIconClicked = () => {
      showHideMenu.value = !showHideMenu.value;
    };
    const closeMenu = () => {
      showHideMenu.value = false;
    };
    // onBeforeMount(async () => {
    //   // console.log()
    //   const initialParam = { skill: skillId.value, proficiency: proficiencyId.value, program_id: programId.value };
    //   const allInitialData: any = await fetchInitialData('/learner/journey/stat', initialParam);

    //   userGroupDetail.value = allInitialData.userObj.user_ad_profile;

    //   localStorage.setItem('allInitialData', JSON.stringify(allInitialData));

    // localStorage.setItem('user_key', allInitialData.skill);
    //   localStorage.setItem('proficiency', allInitialData.proficiency);
    //   localStorage.setItem('videoLink', allInitialData.systemSetting.value.product_video_link);
    //   localStorage.setItem('helpmateLink', allInitialData.systemSetting.value.helpmate_link);
    //   localStorage.setItem('email', allInitialData.userObj.user_ad_profile.email);
    //   console.log('email', allInitialData.userObj.user_ad_profile.email);
    //   lastAccessedOn.value = Moment(userGroupDetail.value.last_accessed_on).format('MM-DD-YYYY hh:mm a');
    //   learnerKey.value = allInitialData.userObj.user_key;
    // });
    return {
      // skillId,
      // proficiencyId,
      // programId,
      // initialData,
      // videoUrl,
      // helpmateLink,
      // userGroupDetail,
      showHideMenu,
      lastAccessedOn,
      learnerKey,
      learnerName,
      menuIconClicked,
      closeMenu,
      showChatbotTooltip,
      env,
      modalVisible,
      closeModal,
      saveAiGuruEvent,
    };
  },
  data() {
    return { isAIUsageGuidelineVisible: false };
  },
  methods: {
    showAIUsageGuideline() {
      this.isAIUsageGuidelineVisible = true;
    },
    closeAIUsageGuideline() {
      this.isAIUsageGuidelineVisible = false;
    },
  },
});
